import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import * as Icon from 'react-bootstrap-icons';


const Navbar = () => {

    return (
  
        <nav className="navbar fixed-top navbar-expand-sm navbar-light bg-info  sticky-top" >
                        
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarToggle1" aria-controls="navbarToggle1" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
            </button>
             
            <div className='navbar' style={{float:'right'}}>
                <a class="nav-link" href="/acrlogin"><input type='button' class='btn btn-danger' value={'Log Out ->'+localStorage.getItem('regEmail')}></input></a> 
            </div>               
        </nav>

    )
}

export default Navbar
